let publicRoutes = [
    {
        path: '*',
        component: () => import(/* webpackChunkName: 'other' */ '../views/404.vue'),
        meta: {
            requiresAuth: false,
            allowAuthenticated: true,
            title: 'Not Found | Appointment Portal RDCD',
            displayTitle: 'Not Found'

        }
    },
    {
        path: '/',
        name: 'Index',
        component: () => import(/* webpackChunkName: 'public' */ '../pages/LandingPage.vue'),
        meta: {
            requiresAuth: false,
            allowAuthenticated: false,
            title: 'Index | Appointment Portal RDCD',
            displayTitle: 'Home'
        }
    }
];

export { publicRoutes };